import styled from '@emotion/styled';
import { FormControl, Select } from '@mui/material';

export const StyledProjectsDropDown = styled(FormControl)(
  ({ theme, width }) => ({
    width: width ? width : '150px',

    div: {
      borderRadius: '100px !important',
      boxShadow: '0px 0px 6px 0px rgba(1, 77, 108, 0.07)',
      backgroundColor: theme.palette.white.main,
      color: theme.palette.blue.text,
      fontWeight: 400,

      div: {
        padding: '12.5px 14px',
        //   height: '48px',
      },
    },

    fieldset: {
      border: `1px solid ${theme.palette.blue.main}`,
    },
  }),
);

export const StyledCompanyDropDown = styled(FormControl)(({ theme }) => ({
  height: '55px',
  fieldset: {
    border: 'unset',
  },
}));

export const StyledSelect = styled(Select)(({ theme }) => ({
  height: '100%',
  backgroundColor: 'rgb(243,243,243) !important',
  fontWeight: '700',
}));
